import Pizzas from '../global/img/promociones/Pizza.jpg';
import GIN from '../global/img/promociones/GIN.jpg';
import Litros from '../global/img/promociones/Litros.jpg';


export const promociones = [
  {
    descripcion: 'Pizzas 2x1',
    restricciones: 'Promoción válida los días miércoles, sólo en el consumo en sucursal',
    img: Pizzas
  },
  {
    descripcion: 'Gin 2x1',
    restricciones: 'Promoción válida los días jueves',
    img: GIN,
  },
  {
    descripcion: 'Litros $99',
    restricciones: 'Promoción válida los días viernes y sábado',
    img: Litros
  },
];
